import { Component, HostBinding } from '@angular/core';

import version from '../../../../../package.json';
import { CONSTANTS } from '../../constants/constant';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent {
  @HostBinding('class') classes = 'main-footer';
  constants = CONSTANTS;

  get currentYear() {
    return new Date().getFullYear();
  }

  get currentAppVersion() {
    return version.version;
  }
}
